import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Code, Copy, ArrowSquareOut, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function EmbedTickerDialog({ projectId }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}/embed/ticker/${projectId}`;
  const snippet = `<iframe src="${url}" width="360" height="520" style="border:0;border-radius:16px;overflow:hidden;box-shadow:0 8px 30px rgba(0,0,0,.12)" title="Live campaign ticker" loading="lazy"></iframe>`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet);
      setCopied(true); toast.success("Embed code copied");
      setTimeout(() => setCopied(false), 2000);
    } catch { toast.error("Copy failed — select and copy manually"); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full gap-1.5" data-testid="embed-ticker-btn">
          <Code size={15} /> Embed live ticker
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="embed-ticker-dialog">
        <DialogHeader>
          <DialogTitle>Embed this campaign's live ticker</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Drop this snippet on any giving page or chapter site. It shows live reach, supporters and where interest is coming from — updating automatically.
        </p>
        <div className="rounded-xl border border-border/60">
          <iframe src={url} title="Ticker preview" className="h-[420px] w-full rounded-t-xl" data-testid="embed-ticker-preview" />
        </div>
        <div className="rounded-lg bg-muted/40 p-3 font-mono text-xs leading-relaxed break-all" data-testid="embed-ticker-snippet">{snippet}</div>
        <div className="flex flex-wrap gap-2">
          <Button size="sm" className="rounded-full gap-1.5" onClick={copy} data-testid="embed-copy-btn">
            {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? "Copied" : "Copy embed code"}
          </Button>
          <Button size="sm" variant="outline" className="rounded-full gap-1.5" asChild>
            <a href={url} target="_blank" rel="noreferrer" data-testid="embed-open-btn"><ArrowSquareOut size={15} /> Open ticker</a>
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">Add a light theme with <code>?theme=light</code>. Live click data streams in once SpLink tenant keys are active.</p>
      </DialogContent>
    </Dialog>
  );
}
